package game.controller

import com.soywiz.korge.input.Input
import game.Game
import view.Terminal

class FadeToWhite: GameController() {
    val fadeDelay = 1000 / 15
    var fadeLevel = 0
    var cooldown = fadeDelay

    override fun onTick(game: Game, input: Input) {
        if (cooldown > 0) {
            cooldown--
        } else {
            fadeLevel++
            cooldown = fadeDelay

            if (fadeLevel >= 5) {
                game.controller = CreditsController(game.collectedAllLore);
            }
        }
    }

    override fun onRender(game: Game, terminal: Terminal) {
        game.renderAll(terminal)
        game.currentRoom.renderRoomLighter(terminal, fadeLevel)
    }
}